/* HURRICANE theme — assets/js/stack.js. Generated by _build/theme/pack.mjs from the static site's own JS. */
(function () {
'use strict';
var W = window, d = document, HRC = W.HRC, $ = HRC.$, $$ = HRC.$$;
var panels = $$('[data-panel]');
if (!panels.length) return;
var filt = $('[data-filter]'), chrome = 0, phone = W.matchMedia ? W.matchMedia('(max-width:900px)') : null;
var svhProbe = null;
function smallVh() {
if (!svhProbe) {
svhProbe = d.createElement('i');
svhProbe.setAttribute('aria-hidden', 'true');
svhProbe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100svh;visibility:hidden;pointer-events:none';
d.body.appendChild(svhProbe);
}
return svhProbe.offsetHeight || Math.min(W.innerHeight, d.documentElement.clientHeight);   // (no svh: the old way)
}
function measure() {
if (filt) d.documentElement.style.setProperty('--filt-h', filt.offsetHeight + 'px');
chrome = parseFloat(getComputedStyle(d.documentElement).scrollPaddingTop) || 0;
var bb = $('[data-bagbar]'), room = smallVh() - chrome - (bb && !bb.hidden ? bb.offsetHeight : 0);
panels.forEach(function (p) {
var m = phone && phone.matches ? $('.panel__media', p) : null;
if (m) p.style.setProperty('--media-max', Math.max(120, room - (p.offsetHeight - m.offsetHeight)) + 'px');
p.style.setProperty('--panel-h', p.offsetHeight + 'px');
var row = $('.vars__row', p); if (row) edge(row);
});
HRC.refresh();
}
function edge(row) {
var max = row.scrollWidth - row.clientWidth, x = row.scrollLeft;
if (max <= 1) { row.removeAttribute('data-edge'); return; }
row.setAttribute('data-edge', x <= 1 ? 'end' : x >= max - 1 ? 'start' : 'both');
}
function reveal(row, b, smooth) {
var max = row.scrollWidth - row.clientWidth;
if (max <= 1 || !b) return;
var rr = row.getBoundingClientRect(), br = b.getBoundingClientRect(), pad = 24, dx = 0;
if (br.left < rr.left + pad) dx = br.left - rr.left - pad;
else if (br.right > rr.right - pad) dx = br.right - rr.right + pad;
if (!dx) return;
var to = Math.max(0, Math.min(max, row.scrollLeft + dx));
try { row.scrollTo({ left: to, behavior: smooth && !(HRC.RM || HRC.paused) ? 'smooth' : 'instant' }); } catch (e) { row.scrollLeft = to; }
}
measure();
HRC.on('bagbar', function () { setTimeout(measure, 0); });
if ('ResizeObserver' in W) { var rt = 0; var ro = new ResizeObserver(function () { cancelAnimationFrame(rt); rt = requestAnimationFrame(measure); }); panels.forEach(function (p) { ro.observe(p); }); }
else W.addEventListener('resize', measure, { passive: true });
var veils = panels.map(function () { return -1; });
HRC.onScroll(function () {
if (HRC.RM || HRC.paused) return;
var vh = W.innerHeight, tops = [], span = Math.max(1, vh - chrome);
for (var i = 1; i < panels.length; i++) tops.push(panels[i].getBoundingClientRect().top);
for (var j = 0; j < tops.length; j++) {
var k = Math.min(1, Math.max(0, 1 - (tops[j] - chrome) / span)), v = Math.round(k * 60) / 100;
if (v !== veils[j]) { veils[j] = v; panels[j].style.setProperty('--veil', v); }
}
});
function stillOf(b) { return { srcs: [b.getAttribute('data-img-avif')], srcset: b.getAttribute('data-img-webp'), src: b.getAttribute('data-img-src'), fp: b.getAttribute('data-fp') }; }
function swapImage(panel, b) {
var box = $('[data-panel-img]', panel), pic = box && box.querySelector('picture');
if (pic) HRC.still.swap(pic, stillOf(b), { alt: b.getAttribute('data-name') || null });
}
function preload(panel) {
var box = $('[data-panel-img]', panel), pic = box && box.querySelector('picture');
if (pic) HRC.still.preload(pic, $$('.vars__b[data-v]', panel).map(stillOf));
}
if (!HRC.saveData && !HRC.slowNet && 'IntersectionObserver' in W) {
var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { preload(e.target); pio.unobserve(e.target); } }); }, { rootMargin: '150% 0px 150% 0px' });
panels.forEach(function (p) { pio.observe(p); });
}
function swapText(el, txt) {
if (!el || el.textContent === txt) return;
if (HRC.RM || HRC.paused) { el.textContent = txt; return; }
el.classList.add('out');
setTimeout(function () { el.textContent = txt; el.classList.remove('out'); }, 180);
}
panels.forEach(function (panel) {
var chips = $$('.vars__b[data-v]', panel);
var first = function () { preload(panel); };
chips.forEach(function (b) { b.addEventListener('pointerdown', first, { once: true }); b.addEventListener('focus', first, { once: true }); });
var row = $('.vars__row', panel);
if (row) {
row.addEventListener('scroll', function () { edge(row); }, { passive: true });
reveal(row, $('.vars__b[aria-checked="true"]', panel), false);
edge(row);
}
chips.forEach(function (b) {
b.addEventListener('click', function () {
if (b.getAttribute('aria-checked') === 'true') return;
chips.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
if (row) reveal(row, b, true);
var i = +b.getAttribute('data-v'), href = b.getAttribute('data-href');
panel.setAttribute('data-variant', i);
swapImage(panel, b);
HRC.scentSwap($('[data-panel-scent]', panel), function () {
var s = $('[data-scent]', panel); if (s) s.textContent = b.getAttribute('data-line') || '';
HRC.notesLine($('[data-notes-line]', panel), b.getAttribute('data-notes'));
});
swapText($('[data-tags]', panel), b.getAttribute('data-tags') || '');
$$('[data-buy]', panel).forEach(function (a) {
var h = a.getAttribute('href') || '', hash = h.indexOf('#') > -1 ? h.slice(h.indexOf('#')) : '';
a.setAttribute('href', href + hash);
});
var media = $('.panel__media', panel);
if (media) media.setAttribute('aria-label', $('.panel__n', panel).textContent + ' — ' + b.getAttribute('data-name'));
var pid = panel.getAttribute('data-product');
if (pid) HRC.emit('variant-tried', { product: pid, variant: i });
HRC.track('select_item', { product: pid, variant: b.getAttribute('data-name'), source: 'catalog' });
});
});
var add = $('[data-panel-add]', panel);
if (add) add.addEventListener('click', function () {
HRC.bag.add(panel.getAttribute('data-product'), +panel.getAttribute('data-variant') || 0, { source: 'catalog' });
});
});
if (panels[1]) HRC.onScroll(function () { if (panels[1].getBoundingClientRect().top < (W.innerHeight || 1) * 0.5) HRC.hintUsed('next'); });
if (filt) {
var btns = $$('[data-filter-to]', filt);
var cur = function (key) { btns.forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-filter-to') === key ? 'true' : 'false'); }); };
var envKey = { car: 'car', home: 'home', body: 'body' };
if ('IntersectionObserver' in W) {
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) {
if (!e.isIntersecting) return;
var env = e.target.getAttribute('data-env');
if (e.target.id === 'lede') cur('all'); else if (envKey[env]) cur(envKey[env]);
});
}, { rootMargin: '-45% 0px -50% 0px' });
var lede = $('#lede'); if (lede) io.observe(lede);
panels.forEach(function (p) { io.observe(p); });
}
cur('all');
var flowTop = function (el) {
var box = el.parentNode, y = box.getBoundingClientRect().top + W.scrollY;
for (var n = box.firstElementChild; n && n !== el; n = n.nextElementSibling) y += n.getBoundingClientRect().height;
return y;
};
btns.forEach(function (b) {
b.addEventListener('click', function (e) {
var key = b.getAttribute('data-filter-to'), id = (b.getAttribute('href') || '').replace(/^#/, ''), t = id && d.getElementById(id);
HRC.track('filter', { key: key });
if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
e.preventDefault();
var y = (t.hasAttribute('data-panel') ? flowTop(t) : t.getBoundingClientRect().top + W.scrollY) - chrome - (parseFloat(getComputedStyle(t).scrollMarginTop) || 0);
y = Math.max(0, Math.round(y));
try { W.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (err) { W.scrollTo(0, y); }
try { history.replaceState(history.state, '', '#' + id); } catch (err) {}
cur(key);
});
});
}
})();